import {
  useEffect,
  useRef,
  type EffectCallback,
  type Inputs
} from 'preact/hooks';

/** Hook only acts like useEffect when the props change, not on mount */
function useEffectOnChange(callback: EffectCallback, inputs?: Inputs) {
  const firstRunRef = useRef(true);

  useEffect(() => {
    if (!firstRunRef.current) {
      callback();
    }
  }, inputs);

  useEffect(() => {
    firstRunRef.current = false;
  }, []);
}

export default useEffectOnChange;
